import React from 'react';
import ReactDOM from "react-dom/client";
// import ReactDOM from 'react-dom'; // Correct import
// import { createRoot } from 'react-dom/client';
import './index.css';
import { store, persistedStore } from './redux/store'; // Import your Redux store
import App from './App';
import { Provider } from 'react-redux';
import reportWebVitals from "./reportWebVitals";


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <App />
  </Provider>

);

reportWebVitals();

// ReactDOM.render(
//   <React.StrictMode>
//     <Provider store={store}>
//       <App />
//     </Provider>
//   </React.StrictMode>,
//   document.getElementById('root')
// );
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
